import {safeRedirect} from "@/helpers";

export default {
    name: 'login',
    data() {
        return {
            email_or_nick: {
                val: '',
                error_msg: ''
            },
            password: {
                val: '',
                error_msg: ''
            },
            error_all: false,
            password_input_type: 'password',
            with_google_connect: window.APP_CONFIG.WITH_GOOGLE_CONNECT,
            with_yahoo_connect: window.APP_CONFIG.WITH_YAHOO_CONNECT,
            with_apple_connect: window.APP_CONFIG.WITH_APPLE_CONNECT || false,
            with_microsoft_connect: window.APP_CONFIG.WITH_MICROSOFT_CONNECT,
            error_google_connect: false,
            error_yahoo_connect: false,
            error_apple_connect: false,
            error_microsoft_connect: false,
            provider: null
        }
    },
    methods: {
        changePasswordInputType() {
            this.password_input_type = this.password_input_type == 'password' ? 'text' : 'password'
        },
        login() {
            let _this = this
            this.error_all = false
            this.email_or_nick.error_msg = ''
            this.password.error_msg = ''
            this.$store.dispatch('auth/login', { params: {
                    email_or_nick: this.email_or_nick.val,
                    password: this.password.val
                }, success_cb(response) {
                    if(response.data.redirect) {
                        safeRedirect(response.data.redirect);
                    } else {
                        _this.$store.dispatch('profile/populateProfiles')
                        _this.$store.dispatch('pub/getFormValues')
                        _this.$store.dispatch('message/getIcebreakers')
                        _this.routeToDashboard()
                    }
                }, error_cb(response) {
                    _this.error_all = true
                    if(typeof response.data.email_or_nick != 'undefined')
                        _this.email_or_nick.error_msg = 'true'
                    if(typeof response.data.password != 'undefined')
                        _this.password.error_msg = 'true'
                    if(response.data.error === 'deleted')
                        _this.$router.push({ name: 'account-deleted', params:
                            {
                                status: 'success',
                                redirect: response.data.redirect || null,
                                hash: response.data.hash || null
                            }
                        })
                }
            })
        },
        routeToDashboard() {
            if(this.showDesktop) {
                this.$router.push({ name: 'user-home' })
            } else {
                 this.$router.push({ name: 'user-mobile-home' })
            }
        },
        checkEmptyEmail(e, key) {
            if(!e.target.value) {
                this.email_or_nick.error_msg = 'true'
            }
        },
        openForgotPass() {
            this.$parent.$emit('open-modal')
        },
        redirectOauth(provider) {
            safeRedirect(`${window.location.origin}/oauth/redirect/${provider}`)
        },
        changeModalToForgotPass() {
            this.$parent.changeModalContent({
                name: 'forgot-pass-pop-up',
                hasCloseButton: true,
                alignCenter: true,
                canCloseBackDrop: false,
                layoutType: 'm-dark'
            })
        },
        capitalize(s) {
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
        }
    },
    computed: {
        showDesktop() {
            return this.$root.$children[0].width > 1199
        },
        oauthProviders() {
            let oauthProviders = [];
            if(this.with_google_connect) {
                oauthProviders.push('google');
            }
            /*
            if(this.with_yahoo_connect) {
                oauthProviders.push('yahoo');
            }
            if(this.with_apple_connect) {
                oauthProviders.push('apple');
            }
             */
            if(this.with_microsoft_connect) {
                oauthProviders.push('microsoft');
            }
            return oauthProviders;
        }
    },
    created() {
        this.$store.dispatch('cookies/setORegister', null)
        this.$store.dispatch('cookies/setOUser', null)
        if(this.$store.getters['auth/isAuthenticated']) {
            this.$router.push({ name: 'user-home' })
        }

        if(this.$route.query.error == 'no_account') {
            this.provider = this.$route.query.provider;
            switch(this.provider) {
                case 'yahoo':
                    this.error_yahoo_connect = true;
                    break;
                case 'apple':
                    this.error_apple_connect = true
                    break
                case 'microsoft':
                    this.error_microsoft_connect = true
                    break
                default:
                    this.error_google_connect = true
            }
        }
    },
    mounted() {
        this.changeModalToForgotPass()
    }
}
